import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService } from '../../../tms-shared';
import { TmsWebBaseEditCreateService } from '../base';
import {
  SalesContractForOrder,
  SalesContractLine,
  SalesContractLineDetails,
  SalesContractLineForCreate,
  SalesContractLineHeader,
  SalesContractLineQuickCreate,
  SalesContractLineSelect,
  SalesOrderFromPreviousIds,
  SalesOrderLineQuickCreate,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesContractLineService extends TmsWebBaseEditCreateService<SalesContractLine, SalesContractLineDetails> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('SalesContractLine', $localize`Sales Contract Line`, httpService, notificationService);
  }

  getForSalesContractHeader(id: string): Observable<SalesContractLineHeader[]> {
    return this.httpService.get<SalesContractLineHeader[]>(`${this.apiUrl}/SalesContractHeader?id=${id}`);
  }

  quickCreate(SalesContractLineQuickCreate: SalesContractLineQuickCreate): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/QuickCreate`, SalesContractLineQuickCreate);
  }

  getSelectItems(customerId: string): Observable<SalesContractLineSelect[]> {
    return this.httpService.get<SalesContractLineSelect[]>(`${this.apiUrl}/GetSelectItems?customerId=${customerId}`);
  }

  getForSalesOrder(id: string): Observable<SalesContractForOrder> {
    return this.httpService.get<SalesContractForOrder>(`${this.apiUrl}/GetForSalesOrder?id=${id}`);
  }

  getOutstandingContracts(): Observable<SalesContractLineForCreate[]> {
    return this.httpService.get<SalesContractLineForCreate[]>(`${this.apiUrl}/GetOutstandingContracts`);
  }

  getFromContract(customerId: string, search: string): Observable<SalesContractLine[]> {
    return this.httpService.get<SalesContractLine[]>(
      `${this.apiUrl}/GetFromContract?customerId=${customerId}&search=${search}`,
    );
  }

  createFromContract(
    salesOrderHeaderId: string,
    ids: SalesOrderFromPreviousIds[],
  ): Observable<SalesOrderLineQuickCreate> {
    return this.httpService.post<SalesOrderLineQuickCreate>(`${this.apiUrl}/CreateFromContract`, {
      salesOrderHeaderId,
      ids,
    });
  }
}
